import { cn } from '@repo/ui/lib/utils'
import { Heading } from './Heading'

// Atom for a page header that reuses the heading component

export function PageHeader(props: React.HTMLAttributes<HTMLHeadingElement>) {
  return <Heading level={1} className={cn('text-3xl', props.className)} {...props} />
}
